import { createContext } from 'react'

interface ScaleContextType {
  scaleName: string
  scaleWeight: number
  scaleConnected: boolean
}

export const ScaleContext = createContext<ScaleContextType>({
  scaleName: null,
  scaleWeight: null,
  scaleConnected: false
})
